import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Provider } from 'react-redux'
import store from './redux/store'
import { Auth0Wrapper } from "./Auth0Wrapper";
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

const Label = ({children}) => <span style={{fontSize: 12}}>{children}</span>;

const nodes = [
  {
    value: 'mars',
    label: <Label>Mars</Label>,
    children: [
        { value: 'phobos', label: <Label>Phobos</Label> },
        { value: 'deimos', label: <Label>Deimos</Label> },
    ],
  },
  {
    value: 'earth',
    label: <Label>Earth</Label>,
    children: [
        { 
          value: 'USA', 
          label: <Label>USA</Label>,
          children: [
              { value: 'newyork', label: <Label>New York</Label> },
              { value: 'sanfran', label: <Label>San Francisco</Label> },
          ],
        },
        { value: 'China', label: <Label>China</Label> },
    ],
  }
];

root.render(
  //<React.StrictMode>
    <Provider store={store}>
      <Auth0Wrapper>
        <App />
      </Auth0Wrapper>
    </Provider>
  //</React.StrictMode>
);


